/**
 * Hakumodeli hakupalkkia varten.
 * Tarpeellinen, koska hakupalkkeja voi olla useita samaan aikaan sivulla,
 * jolloin ei haluta sijoittaa hakuparametrejä kontrolleriin.
 */
app.factory("ApartmentSearchModel",
	["$http", "$timeout", "$rootScope", "ApartmentSearchService", function($http, $timeout, $rootScope, ApartmentSearchService) {

		var self = this;

		/**
		 * Hakuparametrit.
		 * Nämä välitetään ApartmentSearchServicelle.
		 */
		this.query = ApartmentSearchService.CreateQuery();

		/**
		 * Haun mahdolliset sorttausparametrit.
		 */
		this.sortParams = ApartmentSearchService.GetAvailableSortParams();

		this.priceRange = {
			ceil: this.query.MAXPRICE,
			actualceil: 1000000,
			floor: 0,
			step: 10000
		};

		this.rentalPriceRange = {
			ceil: this.query.MAXRENTALPRICE,
			actualceil: 10000,
			floor: 0,
			step: 100
		};

		/**
		 * Hakutulokset, "identifier string" -> {loading, data} pareina.
		 * Huom: itse yksittäiset resultit ovat arrayna datan alla, eli results[identifier].data.results
		 * @type {{}}
		 */
		this.results = {};

		return this;

	}]
);
